module.exports = __webpack_public_path__ + "static/media/logo.90bc46c1.png";